<template>
  <div class="content" :class="[is00 === 'is00' ? 'bgwhile' : is00 === 'is01' ? 'qianse' :
  is00 === 'is02' ? 'baise' : is00 === 'is04' ? 'is04' : '']" :style="{ color: color }">
    <span v-for="item in articleListlast" class="oneHde" @click="toDetail(item.articleShortName)">● {{item.articleTitle}}</span>
  </div>
</template>

<script>
export default {
  props:{
    is00: {
      type: String,
    },
    articleListlast: {
      type: Array
    },
    current: {
      type: Number,
    },
    color: {
      type: String
    }
  },
  methods:{
    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
}
</script>



<style scoped lang="scss">
.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  span{
    display: inline-block;
    margin-bottom: 10px;
    font-size: 14px;
    width: 48%;
    margin-right: 20px;
  }
}

.bgwhile {
  color: #B1B1B1;
}

.qianse {
  color: #ffb7b7;
}

.baise {
  color: #ffffff;
}

.is04 {
  color: #aaaaaa;
  font-size: 12px;
  margin-left: 50px;
  margin-top: 20px;
  border-top: 1px solid black;
  padding: 20px 0 20px;
}
</style>